import React, { useEffect } from 'react';
import MarkdownIt from 'markdown-it';
import Prism from 'prismjs';

const md = new MarkdownIt({
  html: true,
  linkify: false,
});

export default function CodeBlock({ title, markdown }) {
  useEffect(() => {
    Prism.highlightAll();
  });

  return (
    <div className="code-block">
      {title ? <h3>{title}</h3> : null}
      <div
        className="code-text"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: md.render(markdown) }}
      />
    </div>
  );
}
